import {
  RugbyLeagueEventDetailId,
  RugbyLeagueEventStatusId,
} from '@collector/sportsapi-client-legacy'

import {
  createRugbyEventClockConfig,
  rugbyClockFixed,
  rugbyClockRunning,
  rugbyClockTiming,
  type RugbyStatusClockRule,
} from '../../configuration'

const t = rugbyClockTiming

const statusClock: Partial<
  Record<RugbyLeagueEventStatusId, RugbyStatusClockRule>
> = {
  [RugbyLeagueEventStatusId.NotStarted]: rugbyClockFixed(t.fromMatchStart),
  [RugbyLeagueEventStatusId.FirstHalf]: rugbyClockRunning(
    t.fromMatchStart,
    t.periodLength,
  ),
  [RugbyLeagueEventStatusId.Halftime]: rugbyClockFixed(t.periodLength),
  [RugbyLeagueEventStatusId.SecondHalf]: rugbyClockRunning(
    t.periodLength,
    t.afterSecondHalf,
  ),
  [RugbyLeagueEventStatusId.FinishedRegularTime]: rugbyClockFixed(
    t.afterSecondHalf,
  ),
  [RugbyLeagueEventStatusId.WaitingForExtratime]: rugbyClockFixed(
    t.afterSecondHalf,
  ),
  [RugbyLeagueEventStatusId.ExtratimeFirstHalf]: rugbyClockRunning(
    t.afterSecondHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyLeagueEventStatusId.ExtratimeHalftime]: rugbyClockFixed(
    t.afterExtraFirstHalf,
  ),
  [RugbyLeagueEventStatusId.ExtratimeSecondHalf]: rugbyClockRunning(
    t.afterExtraFirstHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyLeagueEventStatusId.FinishedAfterExtratime]: rugbyClockFixed(
    t.afterExtraTime,
  ),
  [RugbyLeagueEventStatusId.WaitingForPenalty]: rugbyClockFixed(
    t.afterPenalties,
  ),
  [RugbyLeagueEventStatusId.Penalties]: rugbyClockFixed(t.afterPenalties),
  [RugbyLeagueEventStatusId.FinishedAfterPenalties]: rugbyClockFixed(
    t.afterPenalties,
  ),
}

export const {
  getEventStatusPeriodLengthMinutes,
  getEventPeriodStartOffsetMinutes,
  getEventClockSeconds,
  isValidEventClockTime,
  getEventClockTime,
} = createRugbyEventClockConfig(statusClock)

export const extraTimeDetailId =
  RugbyLeagueEventDetailId.FirstExtraHalfStartDate
